const KCS = ({ ...props }) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36.0916 50.0081L59.7859 73.706L74.7418 58.7501C77.4161 56.3421 81.5075 56.4492 84.0521 58.9939C86.5968 61.5385 86.7039 65.6299 84.2959 68.3043L64.5592 88.0446C61.9082 90.6518 57.6562 90.6518 55.0051 88.0446L26.5301 59.5622V76.4914C26.5301 80.2277 23.5013 83.2565 19.7651 83.2565C16.0288 83.2565 13 80.2277 13 76.4914V23.5027C13 19.7665 16.0288 16.7377 19.7651 16.7377C23.5013 16.7377 26.5301 19.7665 26.5301 23.5027V40.4319L55.0014 11.9569C57.6517 9.3477 61.9053 9.3477 64.5556 11.9569L84.3069 31.6935C86.7149 34.3679 86.6078 38.4593 84.0631 41.0039C81.5185 43.5486 77.4271 43.6557 74.7528 41.2477L59.7969 26.2918L36.0916 50.0081ZM59.7969 43.2357C57.0574 43.2342 54.5868 44.8833 53.5374 47.4139C52.488 49.9444 53.0665 52.8579 55.0031 54.7956C56.9397 56.7333 59.8529 57.3134 62.384 56.2653C64.9152 55.2173 66.5656 52.7476 66.5656 50.0081C66.5666 48.2119 65.854 46.489 64.5846 45.2182C63.3152 43.9474 61.593 43.233 59.7969 43.232V43.2357Z"
      fill="#23AF91"
    />
  </svg>
);
export default KCS;
